import api from "./api";

const MOCK_QRCODE =
  "00020126580014br.gov.bcb.pix0136a1b2c3d4-e5f6-7890-abcd-ef12345678905204000053039865802BR5925Mock Cobranca Pix Valut6009SAO PAULO62070503***6304ABCD";

/** Mock Pix charges used until GET /pix/charges is wired. */
export const MOCK_PIX_CHARGES = [
  {
    id: "ch_01HX9K2M3N4P5Q6R7S8T9U0V",
    txid: "E12345678202507081200ABCDEF01",
    chargeId: "ch_01HX9K2M3N4P5Q6R7S8T9U0V",
    type: "immediate",
    status: "expired",
    amount: 1000,
    qrcode: MOCK_QRCODE,
    paymentLink: "https://pay.valut.example/pix/ch_01HX9K2M3N4P5Q6R7S8T9U0V",
    createdAt: "2025-07-08T12:00:00.000Z",
    expiresAt: "2025-07-08T13:00:00.000Z",
  },
  {
    id: "ch_02JY8L1K0J9I8H7G6F5E4D3C",
    txid: "E98765432202507071130FEDCBA02",
    chargeId: "ch_02JY8L1K0J9I8H7G6F5E4D3C",
    type: "with_debtor",
    status: "waiting",
    amount: 25000,
    qrcode: MOCK_QRCODE,
    paymentLink: "https://pay.valut.example/pix/ch_02JY8L1K0J9I8H7G6F5E4D3C",
    createdAt: "2025-07-07T11:30:00.000Z",
    expiresAt: "2025-07-14T23:59:59.000Z",
    debtorName: "Maria Silva",
    debtorDocument: "12345678901",
  },
  {
    id: "ch_03KZ7M0L9K8J7I6H5G4F3E2D",
    txid: "E11223344202507061000AABBCC03",
    chargeId: "ch_03KZ7M0L9K8J7I6H5G4F3E2D",
    type: "with_due_date",
    status: "paid",
    amount: 5000,
    qrcode: MOCK_QRCODE,
    paymentLink: "https://pay.valut.example/pix/ch_03KZ7M0L9K8J7I6H5G4F3E2D",
    createdAt: "2025-07-06T10:00:00.000Z",
    expiresAt: "2025-07-20T23:59:59.000Z",
    paidAt: "2025-07-06T14:22:00.000Z",
  },
  {
    id: "ch_04LZ6N9M8L7K6J5I4H3G2F1E",
    txid: "E55667788202507051545DDEEFF04",
    chargeId: "ch_04LZ6N9M8L7K6J5I4H3G2F1E",
    type: "immediate",
    status: "failed",
    amount: 15000,
    qrcode: MOCK_QRCODE,
    paymentLink: "https://pay.valut.example/pix/ch_04LZ6N9M8L7K6J5I4H3G2F1E",
    createdAt: "2025-07-05T15:45:00.000Z",
    expiresAt: "2025-07-05T16:45:00.000Z",
  },
  {
    id: "ch_05MA5O8N7M6L5K4J3I2H1G0F",
    txid: "E99887766202507040900GGHHII05",
    chargeId: "ch_05MA5O8N7M6L5K4J3I2H1G0F",
    type: "immediate",
    status: "returned",
    amount: 8000,
    qrcode: MOCK_QRCODE,
    paymentLink: "https://pay.valut.example/pix/ch_05MA5O8N7M6L5K4J3I2H1G0F",
    createdAt: "2025-07-04T09:00:00.000Z",
    expiresAt: "2025-07-04T10:00:00.000Z",
    paidAt: "2025-07-04T09:30:00.000Z",
  },
  {
    id: "ch_06NB4P7O6N5M4L3K2J1I0H9G",
    txid: "E44332211202507030815JJJJKKK06",
    chargeId: "ch_06NB4P7O6N5M4L3K2J1I0H9G",
    type: "with_due_date",
    status: "canceled",
    amount: 3200,
    qrcode: MOCK_QRCODE,
    paymentLink: "https://pay.valut.example/pix/ch_06NB4P7O6N5M4L3K2J1I0H9G",
    createdAt: "2025-07-03T08:15:00.000Z",
    expiresAt: "2025-07-10T23:59:59.000Z",
  },
];

const USE_MOCK = true; // TODO: set false when GET /pix/charges is available

const normalizeCharge = (item) => ({
  id: item.id || item.charge_id || item.chargeId,
  txid: item.txid || item.tx_id || "",
  chargeId: item.charge_id || item.chargeId || item.id,
  type: item.type || item.charge_type || "immediate",
  status: item.status || "waiting",
  amount: Number(item.amount) || 0,
  qrcode: item.qrcode || item.qr_code || item.pix_copy_paste || "",
  paymentLink: item.payment_link || item.paymentLink || "",
  createdAt: item.created_at || item.createdAt,
  expiresAt: item.expires_at || item.expiresAt,
  paidAt: item.paid_at || item.paidAt,
  debtorName: item.debtor_name || item.debtorName,
  debtorDocument: item.debtor_document || item.debtorDocument,
});

/**
 * Lists Pix charges.
 * TODO: wire to Endpoints.pixChargesList when backend is ready.
 */
export const fetchPixCharges = async (params = {}) => {
  if (USE_MOCK) {
    await new Promise((resolve) => setTimeout(resolve, 300));
    const items = MOCK_PIX_CHARGES.map(normalizeCharge);
    return { success: true, data: { items, row_count: items.length } };
  }

  try {
    const res = await api.get("/pix/charges", { params });
    const payload = res.data?.data ?? res.data;
    const items = (payload?.items ?? []).map(normalizeCharge);
    return {
      success: true,
      data: { items, row_count: payload?.row_count ?? items.length },
    };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.information || "Não foi possível carregar as cobranças",
      description: err.response?.data?.description || "Tente novamente.",
    };
  }
};

export const fetchPixChargeDetail = async (chargeId) => {
  if (USE_MOCK) {
    await new Promise((resolve) => setTimeout(resolve, 200));
    const item = MOCK_PIX_CHARGES.find((c) => c.id === chargeId || c.chargeId === chargeId);
    if (!item) {
      return { success: false, message: "Cobrança não encontrada" };
    }
    return { success: true, data: normalizeCharge(item) };
  }

  try {
    const res = await api.get(`/pix/charges/${chargeId}`);
    return { success: true, data: normalizeCharge(res.data?.data ?? res.data) };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.information || "Não foi possível carregar a cobrança",
    };
  }
};

export const refreshPixChargeStatus = async (chargeId) => fetchPixChargeDetail(chargeId);

export const cancelPixCharge = async (chargeId) => {
  if (USE_MOCK) {
    await new Promise((resolve) => setTimeout(resolve, 400));
    const item = MOCK_PIX_CHARGES.find((c) => c.id === chargeId);
    if (item && (item.status === "waiting" || item.status === "expired")) {
      item.status = "canceled";
      return { success: true, data: normalizeCharge(item) };
    }
    return { success: false, message: "Esta cobrança não pode ser cancelada" };
  }

  try {
    const res = await api.delete(`/pix/charges/${chargeId}`);
    return { success: true, data: normalizeCharge(res.data?.data ?? res.data) };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.information || "Não foi possível cancelar a cobrança",
    };
  }
};
